import { fetchNotifications } from '@/api/v4/notifications.api';
import { QueryKey } from '@/config/query-client';
import { useUserIdle } from '@/hooks/use-idle';
import { useQuery } from '@tanstack/react-query';

export const useNotifications = (userId: number | null) => {
  const isIdle = useUserIdle();

  const handleFetchNotifications = async () => {
    if (!userId) return [];

    const response = await fetchNotifications();
    return response ?? [];
  };

  return useQuery({
    queryKey: [QueryKey.Notifications, userId],
    queryFn: handleFetchNotifications,
    enabled: Boolean(userId) && !isIdle,
    refetchInterval: !isIdle ? 30000 : false,
    staleTime: 10000,
  });
};
